module.exports = __webpack_public_path__ + "img/auction.b1ea638e.svg";